var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"padding":"0px","margin":"0px"},domProps:{"innerHTML":_vm._s(_vm.processedText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }